import React from 'react';
import Page from '../components/Page';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import axios from 'axios';
import StorageService from '../services/StorageService';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form, FormGroup, Input
} from 'reactstrap';
import { MdDone, MdClear, MdCreate, MdFiberManualRecord } from 'react-icons/md';
import AssignCrmUserForm from '../components/AssignCrmUserForm';
import CrmUserForm from '../components/CrmUserForm';
import { Redirect } from 'react-router';
import { roleData } from '../data/jsonData';
import Avatar from '../components/Avatar';
import userImage from '../assets/img/users/profile.jpg';

class CrmUserPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      userModal: false,
      userList: [],
      isEdit: false,
      userId: '',
      redirect: false,
      store: 0,
      storeList: [],
      search: '',
      allList: []
    };
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });

    this.getStoreUser(event.target.value);
  };

  changeSearchHandler = event => {
    const { allList } = this.state;
    let search_key = event.target.value;
    let filtered= [];
    try {
      if(allList.length > 0 && search_key) {
        filtered = allList.filter(el => (el.Email).toLowerCase().includes(search_key.toLowerCase()) 
              || (el.Name).toLowerCase().includes(search_key.toLowerCase())
              || (el.Role).toLowerCase().includes(search_key.toLowerCase()));
      } else {
        filtered = allList;
      }
    } catch (err) {} 
    finally {
      this.setState({
        search: search_key,
        userList: filtered
      });
    }
  };

  toggle = () => () => {
    return this.setState({
      modal: !this.state.modal,
    });
  };

  toggleUser = id => () => {
    return this.setState({
      userModal: !this.state.userModal,
      userId: id,
    });
  };

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    });

    this.setState({
      userModal: false,
      modal: false
    });

    if (reload) {
      window.location.reload();
    } else {
        this.getCrmUser();
    }
  };

  getCrmUser = () => {
    const url = process.env.REACT_APP_API_URL;
    const user = StorageService.getSession('user_info');
    const selected_org = StorageService.getSession('selected_org');
    const data = {
      session_key: user.session_key,
      CompanyID: selected_org.CompanyID,
    };

    axios
      .post(url + ':3000/v1/crm/getUser', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({ userList: result.data, allList: result.data });
      })
      .catch(error => {
        alert(error);
      });
  };

  delete = (id) => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
      Id: id,
    };

    axios
      .post(url + ':3000/v1/crm/deleteUser', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          });
          return;
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'User removed successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });

        this.getCrmUser();
      })
      .catch(error => {
        alert(error);
      });
  };

  checkActive(str_datetime) {
    let color = 'green';
    let lastlogin = new Date(str_datetime);
    var current = new Date();
    var hours = Math.abs(current - lastlogin) / (60 * 60 * 1000);
    if (hours <= 24) {
      color = 'green';
    } else if (hours > 24 && hours <= 72) {
      color = 'yellow';
    } else {
      color = 'red';
    }
    return color;
  }

  componentDidMount() {
    const org = StorageService.getSession('selected_org');
    const found = roleData.some(el => el.role === org.Role);
    const featureFound = org.Features.some(el => el.Feature === 'User');
    const crmFound = org.Features.some(el => el.Feature === 'CRM');
    if (featureFound && found &&crmFound) {
        this.getCrmUser();
    } else {
      this.setState({
        redirect: true,
      });
    }
  }

  render() {
    const user = StorageService.getSession('user_info');
    // if (this.state.redirect) {
    //   return <Redirect to="/" />;
    // }
    return (
      <Page
        className="CompanyUserPage"
        title="CRM User"
        breadcrumbs={[
          { name: 'CRM User', active: true, path: '/crm-user' },
        ]}
      >
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card>
              {this.state.redirect ? <CardBody>
                <span className="access-msg">Invalid access privileges. You are not allowed to manage CRM user.</span>
              </CardBody> : <CardBody>
              <div className="d-flex justify-content-between">
              <Input type="search" placeholder="Search" name="search" value={this.state.search} onChange={this.changeSearchHandler} style={{maxWidth: '250px', marginRight: '8px'}}/>
                <Button
                    className="theme-button theme-button-primary"
                    onClick={this.toggle()}
                >
                    Assign
                </Button>
                </div>
                <small className="text-muted">Search by Email, Name, and Role</small>
                <br/><br/>
                <Table responsive hover className="ps-table tb-col-5">
                  <thead>
                    <tr>
                      <th>Email</th>
                      <th>Name</th>
                      <th>Role</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.userList.length < 1 && (
                      <tr>
                        <td colSpan="4">
                          <div className="ps-empty-data">
                            <div className="empty-content">
                              <MdCreate />
                              <h4>No data to show</h4>
                              <span>
                                Click the 'Assign' button to assign user
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}

                    {this.state.userList.length > 0 &&
                      this.state.userList.map((item, index) => {
                        return (
                          <tr
                            key={index}
                            className={
                              user.email === item.Email ? 'active-user' : ''
                            }
                          >
                            <td>
                              <div className="online">
                                <Avatar
                                  src={
                                    item.Photo === null || item.Photo === ''
                                      ? userImage
                                      : item.Photo
                                  }
                                />

                                <MdFiberManualRecord
                                  className={
                                    'light ' + this.checkActive(item.LastLogin)
                                  }
                                />
                              </div>{' '}
                              {item.Email}
                            </td>
                            <td>{item.Name}</td>
                            <td>{item.Role}</td>
                            <td>
                              {user.email !== item.Email && (
                                <div className="ps-action-button">
                                  <Button
                                    color="link"
                                    className="theme-button theme-button-secondary"
                                    onClick={this.toggleUser(item.Id)}
                                  >
                                    Edit
                                  </Button>

                                  <Button
                                    color="link"
                                    className="theme-button theme-button-primary-light"
                                    onClick={() =>
                                        this.delete(item.Id)
                                      }
                                  >
                                    Remove
                                  </Button>
                                </div>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </CardBody>}
              
            </Card>
          </Col>
        </Row>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle()}
          className={this.props.className}
          centered
        >
          <AssignCrmUserForm
            history={this.props.history}
            onToggleModal={this.toggle}
            closeModal={this.closeModal}
            match={this.props.match}
            data={this.state}
          />
        </Modal>

        <Modal
          isOpen={this.state.userModal}
          toggle={this.toggleUser()}
          className={this.props.className}
          centered
        >
          <CrmUserForm
            history={this.props.history}
            onToggleModal={this.toggleUser}
            closeModal={this.closeModal}
            match={this.props.match}
            data={this.state}
          />
        </Modal>
      </Page>
    );
  }
}
export default CrmUserPage;
